<h2 mat-dialog-title>Partnersuche</h2>
<div mat-dialog-content>
  <form [formGroup]="formGroup" autocomplete="off">
    <div class="input">
      <app-label [control]="name" class="input__label" for="partnerlist_name">Name:</app-label>
      <mat-form-field>
        <input matInput id="partnerlist_name" formControlName="name">
        <mat-error *ngIf="name.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
      </mat-form-field>
    </div>

    <p *ngIf="(partner | async)?.length === 0">Kein Eintrag gefunden.</p>

    <mat-radio-group id="partnerlist_select" class="partner-list" formControlName="select">
      <div [class.no-data-found]="((partner | async) || []).length === 0">

        <table mat-table [dataSource]="dataSource" matSort matSortActive="Nachname" matSortDirection="asc" matSortDisableClear>

          <ng-container matColumnDef="Select" sticky>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <mat-radio-button [value]="row"></mat-radio-button>
            </td>
          </ng-container>

          <ng-container matColumnDef="Anrede" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Anrede</th>
            <td mat-cell *matCellDef="let row"> {{ enumService.getAnrede(row.Anrede) }} </td>
          </ng-container>

          <ng-container matColumnDef="Vorname" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vorname</th>
            <td mat-cell *matCellDef="let row"> {{ row.Vorname }} </td>
          </ng-container>

          <ng-container matColumnDef="Nachname" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nachname</th>
            <td mat-cell *matCellDef="let row"> {{ row.Privatperson ? row.Nachname : row.Firmenname }} </td>
          </ng-container>

          <ng-container matColumnDef="Strasse">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Straße</th>
            <td mat-cell *matCellDef="let row"> {{ row.Adresse?.Strasse }} </td>
          </ng-container>

          <ng-container matColumnDef="Plz">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PLZ</th>
            <td mat-cell *matCellDef="let row"> {{ row.Adresse?.Plz }} </td>
          </ng-container>

          <ng-container matColumnDef="Ort">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ort</th>
            <td mat-cell *matCellDef="let row"> {{ row.Adresse?.Ort }} </td>
          </ng-container>

          <ng-container matColumnDef="Geburtsdatum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Geburtsdatum</th>
            <td mat-cell *matCellDef="let row"> {{ row.Geburtsdatum | date }} </td>
          </ng-container>

          <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mail</th>
            <td mat-cell *matCellDef="let row"> {{ row.Email }} </td>
          </ng-container>

          <ng-container matColumnDef="Telefonnummer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefon</th>
            <td mat-cell *matCellDef="let row"> {{ row.Telefonnummer }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>

        </table>

        <mat-paginator [pageSize]="8" hidePageSize showFirstLastButtons></mat-paginator>
      </div>
    </mat-radio-group>
    <div class="text_info" *ngIf="selectedPartner && !validateAlter(selectedPartner.Geburtsdatum)">
      <label class="custom-select__label red-error-text-circle" for="Geburtsdatum">Das Alter dieser Person fällt unter ein anfragepflichtiges Sonderrisiko. <span [innerHTML]="(translateService.get('SPEZIELLEANFRAGEEXPERT')|async)"></span></label>
      <div class="info">
        <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('ANNAHMERICHTLINIENINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button class="button--primary" (click)="close()">Abbrechen</button>
</div>

